import Highway from '@dogstudio/highway'
import gsap from 'gsap'
import App from '../App';

export default class MenuTransition extends Highway.Transition {
  getElems() {
    this.menu = document.body.querySelector('.menu')
    this.menuBackgroundGradient = this.menu.querySelector('.menu__background-gradient')
    this.menuBackground = this.menu.querySelector('.menu__background')
    this.menuTitles = this.menu.querySelectorAll('.menu__items .infinite-text__wrapper')
    this.body = document.body
    this.pageTitle = document.querySelector('h1')
    this.divPageTo = this.menu.querySelector('.menu__page-to')
    this.spansInfiniteText = this.divPageTo.querySelectorAll('span')
    this.spansWrapperInfiniteText = this.divPageTo.querySelector('.infinite-text')
  }

  in({ from, to, done }) {
    this.from = from
    this.to = to
    this.done = done

    if (App.menuAnimation.isActive()) {
      App.menuAnimation.eventCallback('onComplete', this.inAnimation.bind(this))
    } else this.inAnimation()
  }

  inAnimation() {
    this.from.remove()
    this.pageTitleWrapper = this.to.querySelector('.infinite-text.title .infinite-text__wrapper')

    this.getElems()
    this.startSmoothScroll()
    this.addTitlePageToLoader(this.to).then(this.hideLoader.bind(this, this.to))

    this.done()
  }

  out({ done }) {
    this.getElems()
    this.stopSmoothScroll()
    this.hideMenu()
    
    done()
  }

  addTitlePageToLoader() {
    return new Promise((resolve) => {
      for (let i = 0; i < this.spansInfiniteText.length; i++) {
        this.spansInfiniteText[i].textContent = this.pageTitle.textContent
      }
  
      this.spansWrapperInfiniteText.style.height = this.spansInfiniteText[0].offsetHeight + 'px'
      this.spansWrapperInfiniteText.classList.add('play-animation')

      this.pageTitleWrapper.style.animation = 'none'
      this.pageTitleWrapper.offsetHeight
      this.pageTitleWrapper.style.animation = null
  
      gsap.to(this.divPageTo, {
        alpha: 1,
        duration: 0.6,
        ease: 'power2.out',
        onComplete: resolve
      })
    })
  }

  hideLoader() {
    const tl = gsap.timeline({
      onComplete: () => {
        this.spansWrapperInfiniteText.classList.remove('play-animation')
      }
    })

    tl.addLabel('start', 0)

    tl.to([this.menuBackgroundGradient, this.divPageTo], {
      y: '100vh',
      duration: 1,
      ease: 'power3.inOut'
    }, 'start')

    tl.to(this.spansWrapperInfiniteText, {
      y: '-100vh',
      duration: 1,
      ease: 'power3.inOut'
    }, 'start')

    tl.to(document.body, {
      duration: 0,
      onComplete: () => {
        document.body.classList.remove('menu-open')
      }
    }, '-=0.7')

    tl.set(this.divPageTo, { alpha: 0 })

    tl.set([this.divPageTo, this.spansWrapperInfiniteText], {
      y: 0
    })

    tl.set(this.menuBackgroundGradient, {
      y: 0,
      scaleY: 0
    })
  }

  hideMenu() {
      App.menuAnimation = gsap.timeline()

      App.menuAnimation.to(this.menuBackgroundGradient, {
        scaleY: 2,
        duration: 1.1,
        ease: 'power3.inOut'
      })

      App.menuAnimation.set([this.menuBackground, this.menuTitles], { alpha: 0 })
  }

  startSmoothScroll() {
    if (!App.smoothScroll) return

    if (App.isMobile) {
      window.scrollTo(0, 0)
      App.smoothScroll.init()
    } else {
      App.smoothScroll.setScroll(0, 0)
      App.smoothScroll.update()
      App.smoothScroll.scroll.scrollbarThumb.style.height = `${window.innerHeight * window.innerHeight / (App.smoothScroll.scroll.instance.limit + window.innerHeight)}px`
      App.smoothScroll.scroll.scrollBarLimit = window.innerHeight - App.smoothScroll.scroll.scrollbarThumb.getBoundingClientRect().height
      App.smoothScroll.scroll.startScrolling()
      App.smoothScroll.start()
    }
  }

  stopSmoothScroll() {
    if (!App.smoothScroll) return

    if (App.isMobile) App.smoothScroll.destroy()
    else {
      App.smoothScroll.scroll.stopScrolling()
      App.smoothScroll.stop()
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/transitions/MenuTransition.js